/**
 * Unzer payment panel: card.
 *
 * Markup contract, on the .crdPay_item of the payment method:
 *   <div class="crdPay_item"
 *        x-data="unzerMethod({ method: 'unzercreditcard', environment: 'sandbox', errorText: '…' })">
 *     <div x-ref="storedCard">…<button @click="editStoredCard()">…</button></div>
 *     <unzer-payment x-ref="payment" …>
 *     <p class="errors_wrapper" x-show="error" x-text="error"></p>
 *
 * Like the Adyen panels this one registers a hook with the enclosing validatedForm.
 * The hook tokenises the card, hands the type id to the shop and only then lets the
 * step's form through. A further Unzer method with a browser part becomes another
 * type here, not another file.
 */
import { postAction } from '../shell/request.js';

const endpoint = (status) => `/${URLSEGMENT}index.php?cl=payment&fnc=unzer_ajaxHandlePayment&status=${status}`;

document.addEventListener('alpine:init', () => {
    Alpine.data('unzerMethod', ({ type = 'card', method, environment, errorText }) => ({
        hasStoredCard: false,
        paymentTypeId: null,
        error: '',

        init() {
            this.hasStoredCard = Boolean(this.$refs.storedCard);
            this.addBeforeSubmit(() => this.confirm());
        },

        /** Drops the card the session still holds and asks for a new one. */
        editStoredCard() {
            this.hasStoredCard = false;
            this.paymentTypeId = null;
        },

        async confirm() {
            if (this.paymentId !== method) {
                return true;
            }
            // an untouched stored card and an already tokenised one both need no second run
            if (this.hasStoredCard || this.paymentTypeId !== null) {
                return true;
            }

            this.error = '';

            try {
                await customElements.whenDefined('unzer-payment');

                const response = await this.$refs.payment.submit();
                if (!response?.submitResponse?.success) {
                    return this.reject(response);
                }

                const paymentTypeId = response.submitResponse.data.id;
                const answer = await postAction(endpoint('SUCCESS'), { paymentId: paymentTypeId, paymentType: method });
                if (answer !== 'OK') {
                    return this.reject(answer);
                }

                this.paymentTypeId = paymentTypeId;

                return true;
            } catch (error) {
                return this.reject(error);
            }
        },

        async reject(reason) {
            this.error = errorText;
            await postAction(endpoint('ERROR'), { paymentType: method, message: JSON.stringify(reason ?? null) });
            if (environment !== 'live') {
                console.error('[Unzer]', reason);
            }

            return false;
        },
    }));
});
